import React from 'react';
import { aboutService } from '../../services/aboutService';
import { getMediaUrl } from '../../services/api';

export default class WorkPerformanceOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            section: null
        };
    }

    async componentDidMount() {
        try {
            const res = await aboutService.getAboutContent();
            if (res.success && res.data && res.data.sections && res.data.sections.work_performance) {
                this.setState({ section: res.data.sections.work_performance }, () => {
                    this.initKnobs();
                });
            } else {
                this.initKnobs();
            }
        } catch (err) {
            console.error('Failed to load about work performance section:', err);
            this.initKnobs();
        }
    }

    initKnobs() {
        const $ = window.$;
        if ($ && $('.dial').length) {
            $('.dial').appear(function () {
                var elm = $(this);
                var perc = elm.attr('value');
                elm.knob({
                    'value': 0,
                    'min': 0,
                    'max': 100,
                    'skin': 'tron',
                    'readOnly': true,
                    'thickness': 0.15,
                    'dynamicDraw': true,
                    'displayInput': false
                });
                $({ value: 0 }).animate({ value: perc }, {
                    duration: 2000,
                    easing: 'swing',
                    progress: function () {
                        elm.val(Math.ceil(this.value)).trigger('change');
                    }
                });
            }, { accY: 20 });
        }

        if ($ && $(".count-box").length) {
            $(".count-box").appear(function () {
                var $t = $(this),
                    n = $t.find(".count-text").attr("data-stop"),
                    r = parseInt($t.find(".count-text").attr("data-speed"), 10);
                if (!$t.hasClass("counted")) {
                    $t.addClass("counted");
                    $({ countNum: $t.find(".count-text").text() }).animate({ countNum: n }, {
                        duration: r,
                        easing: "linear",
                        step: function () {
                            $t.find(".count-text").text(Math.floor(this.countNum));
                        },
                        complete: function () {
                            $t.find(".count-text").text(this.countNum);
                        },
                    });
                }
            }, { accY: 0 });
        }
    }

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        const { section } = this.state;
        if(!section)return null;

        const tagline = section && section.tagline ? section.tagline : '';
        const title = section && section.title ? section.title : '';
        const description = section && section.description ? section.description : '';
        const percentage = section && section.percentage ? section.percentage : 0;
        const subHeading = section && section.subHeading ? section.subHeading : '';
        const subDescription = section && section.subDescription ? section.subDescription : '';
        const imgUrl = section && section.image ? getMediaUrl(section.image) : ('');

        return (
            <>
                <section className="work-perfomance-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Start Work Performance One Content */}
                            <div className="col-xl-7">
                                <div className="work-perfomance-one__content">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>{tagline}</h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title" dangerouslySetInnerHTML={{ __html: title }} />
                                        <p className="sec-title__text">{description}</p>
                                    </div>

                                    <div className="work-perfomance-one__content-bottom">
                                        <div className="progress-box">
                                            <div className="inner-box">
                                                <div className="graph-outer">
                                                    <input
                                                        type="text"
                                                        className="dial"
                                                        data-fgcolor="#ff5e14"
                                                        data-bgcolor="#ebebeb"
                                                        data-width="100"
                                                        data-height="100"
                                                        data-linecap="normal"
                                                        value={percentage}
                                                        readOnly
                                                    />
                                                    <div className="inner-text count-box">
                                                        <span className="count-text" data-stop={percentage} data-speed="2000"></span>
                                                        <span className="count-Parsent">%</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-box">
                                            <h2>{subHeading}</h2>
                                            <p>{subDescription}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Work Performance One Content */}

                            {/* Start Work Performance One Img */}
                            <div className="col-xl-5">
                                <div className="work-perfomance-one__img">
                                    <img src={imgUrl} alt="Work Performance" />
                                </div>
                            </div>
                            {/* End Work Performance One Img */}

                        </div>
                    </div>
                </section>
            </>
        );
    }
}